import { __decorate } from "tslib";
import React from 'react';
import { observer } from 'mobx-react';
import { action, observable } from 'mobx';
import { ProgressType } from 'choerodon-ui/lib/progress/enum';
import { getConfig } from 'choerodon-ui/lib/configure';
import KeyCode from 'choerodon-ui/lib/_util/KeyCode';
import { TextField } from '../text-field/TextField';
import Icon from '../icon';
import { open } from '../modal-container/ModalContainer';
import IntlList from './IntlList';
import localeContext, { $l } from '../locale-context';
import Progress from '../progress';
import { Size } from '../core/enum';
import message from '../message';
import exception from '../_util/exception';
import autobind from '../_util/autobind';
import { stopEvent } from '../_util/EventManager';
import isSame from '../_util/isSame';
let IntlField = class IntlField extends TextField {
    constructor() {
        super(...arguments);
        this.openModal = async () => {
            if (!this.modal) {
                const { modalProps, maxLengths } = this.props;
                const { record, lang, name, element } = this;
                const { supports } = localeContext;
                const maxLengthList = {};
                Object.keys(supports).map(key => {
                    maxLengthList[key] = maxLengths && key !== lang ? maxLengths[key] || element.maxLength : element.maxLength;
                    return null;
                });
                if (record) {
                    this.setLoading(true);
                    try {
                        if (element && !isSame(this.getValue(), element.value)) {
                            this.syncValueOnBlur(element.value);
                        }
                        await record.tls(name);
                    }
                    catch (err) {
                        message.error(exception(err));
                        return;
                    }
                    finally {
                        this.setLoading(false);
                    }
                }
                this.storeLocales();
                this.modal = open({
                    title: $l('IntlField', 'modal_title'),
                    children: React.createElement(IntlList, { readOnly: this.readOnly, disabled: this.disabled, record: record, name: name, lang: lang, maxLengths: maxLengthList }),
                    onClose: this.handleIntlListClose,
                    onOk: this.handleIntlListOk,
                    onCancel: this.handleIntlListCancel,
                    destroyOnClose: true,
                    ...modalProps,
                });
            }
        };
        this.handleIntlListClose = async () => {
            delete this.modal;
            this.focus();
        };
    }
    setLoading(loading) {
        this.loading = loading;
    }
    async handleIntlListOk() {
        const { supports } = localeContext;
        const languages = Object.keys(supports);
        const { record, name, field } = this;
        if (record && field) {
            const tlsKey = getConfig('tlsKey');
            return (await Promise.all(languages.map(language => {
                const intlField = record.getField(`${tlsKey}.${name}.${language}`);
                return intlField ? intlField.checkValidity(false) : true;
            }))).every(Boolean);
        }
    }
    async handleIntlListCancel() {
        const { name, record } = this;
        if (record) {
            const tlsKey = getConfig('tlsKey');
            record.set(`${tlsKey}.${name}`, this.locales);
        }
    }
    handleKeyDown(e) {
        if (e.keyCode === KeyCode.DOWN) {
            stopEvent(e);
            this.openModal();
        }
        super.handleKeyDown(e);
    }
    handleBlur(e) {
        if (this.modal) {
            e.preventDefault();
        }
        super.handleBlur(e);
    }
    storeLocales() {
        const { name, record } = this;
        if (record) {
            const tlsKey = getConfig('tlsKey');
            this.locales = { ...record.get(`${tlsKey}.${name}`) };
        }
    }
    getSuffix() {
        const { suffix } = this.props;
        return this.wrapperSuffix(this.loading ? (React.createElement(Progress, { size: Size.small, type: ProgressType.loading })) : (suffix || React.createElement(Icon, { className: `${this.prefixCls}-intl`, type: "language" })), {
            onClick: this.openModal,
        });
    }
    componentWillUnmount() {
        if (this.modal) {
            this.modal.close();
        }
    }
};
IntlField.displayName = 'IntlField';
__decorate([
    observable
], IntlField.prototype, "loading", void 0);
__decorate([
    action
], IntlField.prototype, "setLoading", null);
__decorate([
    autobind
], IntlField.prototype, "handleIntlListOk", null);
__decorate([
    autobind
], IntlField.prototype, "handleIntlListCancel", null);
__decorate([
    autobind
], IntlField.prototype, "handleKeyDown", null);
__decorate([
    autobind
], IntlField.prototype, "handleBlur", null);
IntlField = __decorate([
    observer
], IntlField);
export default IntlField;
